module.exports = __webpack_public_path__ + "static/sport/bgi-tag-left.0673d42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/bgi-tag-left.png
// module id = DETP
// module chunks = 0